<template>
  <div :class="['nv-recharge-store-box', type === 'card' ? 'card-box' : 'page-box']">
    <slot name="prepend"></slot>
    <div class="content">
      <div
        :class="['store-item', activeCoinItem === index ? 'active' : '']"
        @click="selectItem(index)"
        v-for="(item, index) in types"
        :key="index"
      >
        <div v-if="index === 1" class="label-box">
          <NvLabel type="H" />
        </div>
        <img :src="item.icon" :width="item.iconW" :height="item.iconH" />
        <div class="coin-text">{{ item.coin }} Coins</div>
        <div class="bouns">
          <template v-if="item.bonus">
            <span class="val fw500">+{{ item.bonus.value }} </span>
            Bonus
            <span class="per">{{ item.bonus.per }}</span>
          </template>
        </div>
        <div class="money-text">{{ item.php }} PHP</div>
      </div>
    </div>
    <div class="pay-method-box">
      <div class="title fw500">Payment Method</div>
      <div class="title-tip">
        Enjoy the best value with recommended payment.
      </div>

      <div class="content method-cards-box">
        <div
          @click="selectPayMethod(index)"
          v-for="(item, index) in payList"
          :key="index"
          :class="['pay-item', activePayMethodItem === index ? 'active' : '']"
        >
          <img :src="item.icon" width="24" />
          <div class="bank-text">{{ item.label }}</div>
        </div>
      </div>
    </div>

    <slot name="append"></slot>

    <div class="bottom-bar">
      <div class="order-tip">Purchase Order: {{ currentItem.coin }} Coins = {{ currentItem.php }} PHP</div>
      <NvButton :loading="pending" @click.native="buy" square class="pay-btn fw500" text="PAY NOW" />
    </div>
  </div>
</template>

<script>
import Coin50 from "@/assets/images/coin50.png";
import Coin250 from "@/assets/images/coin250.png";
import Coin800 from "@/assets/images/coin800.png";
import Coin1300 from "@/assets/images/coin1300.png";
import { buyCoins } from "@/service/api";
import { setToStorage, getFromStorage } from "@/service/utils";
import NvButton from "@/components/widget/NvButton";
import NvLabel from "@/components/widget/NvLabel";
// icons
import IconATM from "@/assets/images/atm.png";
import IconCoin from "@/assets/images/coin-ph.png";
import IconDragonPay from "@/assets/images/dragon-pay.png";
import IconGCash from "@/assets/images/gcash.png";
import IconGrabPay from "@/assets/images/grab-pay.png";
import IconOnlineBank from "@/assets/images/online-bank.png";
import IconCarrierBilling from "@/assets/images/carrier-billing.png";
import IconOTC from "@/assets/images/otc.png";

const cardTypes = [
  { type: 1, coin: 50, php: 50, icon: Coin50, iconH: 40, iconW: 50, value: "coin_50" },
  {
    type: 2,
    coin: 250,
    php: 200,
    icon: Coin250,
    iconH: 40,
    iconW: 63,
    value: "coin_250",
    bonus: { value: 50, per: "25%" }
  },
  {
    type: 3,
    coin: 800,
    php: 600,
    icon: Coin800,
    iconH: 40,
    iconW: 47,
    value: "coin_800",
    bonus: { value: 200, per: "33%" }
  }
];

const pageTypes = [
  ...cardTypes,
  {
    type: 4,
    coin: 1700,
    php: 1200,
    icon: Coin1300,
    iconH: 40,
    iconW: 77,
    value: "coin_1700",
    bonus: { value: 500, per: "40%" }
  }
];

const cardPayList = [
  { icon: IconGCash, label: "GCash", value: "GCASH" },
  { icon: IconCarrierBilling, label: "Carrier Billing", value: "CARRIER_BILLING" },
  { icon: IconCoin, label: "Coins.ph", value: "COINS" },
  { icon: IconOnlineBank, label: "Online Bank", value: "ONLINE_BANK" }
];

const pagePayList = [
  ...cardPayList,
  { icon: IconGrabPay, label: "Grab Pay", value: "GRABPAY" },
  { icon: IconDragonPay, label: "Dragonpay", value: "DRAGONPAY" },
  { icon: IconATM, label: "OTC Bank&ATMs", value: "OTC_BANKS_ATM" },
  { icon: IconOTC, label: "OTC Stores Bill Payment", value: "OTC_STORE" }
];

const COIN_KEY = "LAST_PAID_COIN_TYPE";
const PAY_METHOD_KEY = "LAST_PAY_METHOD";

export default {
  name: "RechargeCard",
  components: { NvButton, NvLabel },
  props: {
    redirect: String,
    type: {
      type: String,
      default: "card" // card is in reader page & page is in recharge page
    }
  },
  data() {
    return {
      pending: false,
      activeCoinItem: 1,
      activePayMethodItem: 0
    };
  },
  computed: {
    types() {
      return this.type === "card" ? cardTypes : pageTypes;
    },
    payList() {
      return this.type === "card" ? cardPayList : pagePayList;
    },
    myCoinsCount() {
      return this.$store.state.user.coins_amount || 0;
    },
    fromPage() {
      return this.$route.name === "recharge-store" ? "Recharge Store" : "Charge Dialog";
    },
    currentItem() {
      return this.types[this.activeCoinItem] || this.types[0];
    },
    currentPayMethod() {
      return this.payList[this.activePayMethodItem] || this.payList[0];
    }
  },
  methods: {
    selectItem(index) {
      if (!this.pending) {
        this.activeCoinItem = index;
      }
    },
    selectPayMethod(index) {
      if (!this.pending) {
        this.activePayMethodItem = index;
      }
    },
    buy(flag = true) {
      const coin = this.currentItem;
      const payMethod = this.currentPayMethod;
      if (this.pending) return;
      setToStorage(COIN_KEY, coin);
      setToStorage(PAY_METHOD_KEY, payMethod.value);
      // restore button won't trigger this event
      if (flag) {
        window.$event("Click_pay_now_btton", {
          coin: coin.coin,
          from: this.fromPage,
          method: payMethod.label
        });
      }
      this.navigateWithAuth(() => {
        const code = coin.value;
        const redirectUrl = this.redirect || window.location.href;
        this.pending = true;
        buyCoins({
          commodity: code,
          redirect_url: redirectUrl,
          payment_type: payMethod.value
        })
          .then(res => {
            this.pending = false;
            window.location.href = res.redirect_url;
          })
          .catch(() => {
            // maybe useless because page is changed in `then` callback
            // here just for ensurance
            this.pending = false;
          });
      });
    },
    recoverPayMethod() {
      const lastPayMethod = getFromStorage(PAY_METHOD_KEY);
      let index = 0;
      if (lastPayMethod) {
        if (this.type === "page") {
          index = this.getIndex(pagePayList, lastPayMethod);
        } else if (this.type === "card") {
          index = this.getIndex(cardPayList, lastPayMethod);
        } else {
          index = 0;
        }
      } else {
        index = 0;
      }
      this.activePayMethodItem = index < 0 ? 0 : index;
    },
    recoverCoinType() {
      // const lastPaid = getFromStorage(COIN_KEY);
      // let index = 1;
      // if (lastPaid && lastPaid.value) {
      //   if (this.type === "page") {
      //     index = this.getIndex(pageTypes, lastPaid.value);
      //   } else if (this.type === "card") {
      //     index = this.getIndex(cardTypes, lastPaid.value);
      //   } else {
      //     index = 1;
      //   }
      // } else {
      //   index = 1;
      // }
      // this.activeCoinItem = index < 0 ? 0 : index;

      // they want always select second one even if it's selected before
      // I don't want to argue this shit, just do it
      this.activeCoinItem = 1;
    },
    getIndex(list = [], item) {
      return list.map(i => i.value).indexOf(item);
    }
  },
  mounted() {
    this.recoverPayMethod();
    this.recoverCoinType();
  }
};
</script>

<style lang="scss" scoped>
@mixin active-item {
  border: 1px solid $color-main;
  background: linear-gradient(135deg, white, #ece5ff);
  // box-shadow: 0px 8px 4px 0px rgba(225, 232, 241, 0.5);
}
.nv-recharge-store-box {
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  &.page-box {
    .content {
      flex-wrap: wrap;
      justify-content: space-between;
      .store-item,
      .pay-item {
        width: 44vw;
        margin-top: 8px;
        .bouns .per {
          display: inline;
          margin: 0;
        }
      }
    }
  }
  .content {
    display: flex;
    justify-content: center;
    justify-content: space-between;
    width: 100%;
    .store-item {
      position: relative;
      .label-box {
        position: absolute;
        top: 0;
        left: 0;
      }
    }
    .store-item,
    .pay-item {
      width: 28vw;
      height: 42vw;
      display: inline-flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      border-radius: 8px;
      border: 1px solid $color-border;
      &.active {
        @include active-item();
        .money-text,
        .bank-text {
          color: $color-main;
        }
      }
      .coin-text {
        font-weight: 500;
        padding-top: 8px;
        padding-bottom: 16px;
      }
      .bouns {
        font-size: $fs-xs;
        text-align: center;
        height: 25px;
        .val,
        .per {
          color: #ff217b;
        }
        .per {
          border: 1px solid #ff217b;
          padding: 0 8px;
          border-radius: 8px;
          margin-top: 4px;
          display: block;
          margin: 2px 10%;
        }
      }
      .money-text,
      .bank-text {
        margin-top: 16px;
        color: $fc-grey;
        font-size: $fs-s;
      }
    }
    .store-item {
      padding-top: 16px;
    }
    .pay-item {
      height: 20vw;
      width: 44vw;
      margin-top: 10px;
    }
  }
  .method-cards-box {
    flex-wrap: wrap;
  }
  .pay-method-box {
    margin-top: 32px;
    width: 100%;
    align-self: flex-start;
    .title-tip {
      color: $fc-grey;
      padding: 8px 0;
      font-size: $fs-xs;
      font-weight: 300;
    }
  }
  .bottom-bar {
    width: 100%;
    position: fixed;
    text-align: center;
    bottom: 0;
    .order-tip {
      color: $color-main;
      background: #ede6ff;
      padding: 4px 0;
      font-size: $fs-xs;
    }
    .pay-btn {
      background: linear-gradient(135deg, $bg-l-end, $bg-l-start);
      color: white;
      width: 100%;
      height: 45px;
      font-size: $fs-main;
    }
  }
}
</style>
